import Swiper from 'swiper';

export default () => ({
	id: '',
	swiperObject: null,
	init() {
		this.id = this.$id('swiper');
		this.$nextTick(() => {
			this.swiperObject = new Swiper(`.swiper-gallery-${this.id}`, {
				spaceBetween: 8,
				loop: true,
				loopedSlides: 4,
				slidesPerView: 'auto'
			});
		});
	},
});
